module.exports = __webpack_public_path__ + "static/media/BB2.eaa89e36.png";